import type { ToastItem } from "./toastContext";
import styles from "./Toast.module.css";

type ToastViewportProps = {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
};

const VARIANT_CLASS: Record<ToastItem["variant"], string> = {
  error: styles.error,
  success: styles.success,
  info: styles.info,
};

export function ToastViewport({ toasts, onDismiss }: ToastViewportProps) {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.viewport}
      aria-live="polite"
      aria-relevant="additions"
      data-testid="toast-viewport"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${VARIANT_CLASS[toast.variant]}`}
          role={toast.variant === "error" ? "alert" : "status"}
          data-testid={`toast-${toast.variant}`}
        >
          <p className={styles.message} data-testid="toast-message">
            {toast.message}
          </p>
          <button
            type="button"
            className={styles.dismiss}
            aria-label="Dismiss notification"
            onClick={() => onDismiss(toast.id)}
            data-testid="toast-dismiss-button"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
